(() => {
  const dialog = document.getElementById('cxk-case-reward');
  if (!dialog || dialog.dataset.initialized || !dialog.showModal) return;
  dialog.dataset.initialized = 'true';
  const launcher = document.getElementById('cxk-reward-launcher');
  const key = 'cxk-case-reward-v1';
  const pendingKey = key + '-pending';
  const stateKey = key + '-state';
  const read = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
  const remove = (storage, name) => { try { storage.removeItem(name); } catch {} };
  const decode = raw => { try { return JSON.parse(raw); } catch { return null; } };
  const steps = [...dialog.querySelectorAll('[data-reward-step]')];
  const cards = [...dialog.querySelectorAll('[data-reward-case]')];
  const teasers = (dialog.dataset.teasers || 'So close 😅|Not today 🙃|Almost 👀|Nice try 😎').split('|').filter(Boolean);
  const saved = decode(read(localStorage, stateKey));
  const state = saved && saved.expires > Date.now() && ['pick', 'email', 'code'].includes(saved.stage) && Array.isArray(saved.picks)
    ? saved : {stage: 'pick', picks: [], expires: Date.now() + 7 * 86400000};
  let count = 0;
  let eligible = false;
  let opener = null;
  let previousOverflow = '';
  let retry = null;
  let advance = null;
  let submitted = false;
  let shown = false;
  let completed = state.stage === 'code';
  const persist = () => write(localStorage, stateKey, JSON.stringify(state));
  const burst = (large = false) => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || !document.documentElement.animate) return;
    const layer = document.createElement('div');
    layer.className = 'cxk-reward-confetti';
    layer.setAttribute('aria-hidden', 'true');
    dialog.appendChild(layer);
    for (let i = 0; i < (large ? 30 : 16); i++) {
      const piece = document.createElement('i');
      piece.style.background = ['#d9232e', '#111', '#ffd34d', '#d9232e'][i % 4];
      layer.appendChild(piece);
      const x = (Math.random() - .5) * (large ? 440 : 260);
      const y = 110 + Math.random() * 220;
      piece.animate([
        {transform: 'translate(0,-20px) rotate(0deg)', opacity: 1},
        {transform: 'translate(' + x + 'px,' + y + 'px) rotate(' + (180 + Math.random() * 540) + 'deg)', opacity: 0}
      ], {duration: 850 + Math.random() * 300, easing: 'cubic-bezier(.15,.65,.45,1)', fill: 'forwards'});
    }
    setTimeout(() => layer.remove(), 1300);
  };
  const showStep = name => {
    state.stage = name;
    persist();
    steps.forEach(step => { step.hidden = step.dataset.rewardStep !== name; });
    const heading = dialog.querySelector('[data-reward-step="' + name + '"] h2');
    dialog.setAttribute('aria-labelledby', heading.id || (heading.id = 'cxk-reward-' + name + '-title'));
    if (dialog.open) heading.focus();
  };
  const updateCount = () => {
    const counter = dialog.querySelector('[data-reward-count]');
    counter.textContent = counter.dataset.template.replace('[count]', String(count));
  };
  for (const pick of state.picks.slice(0, 3)) {
    if (!Number.isInteger(pick.index) || !cards[pick.index] || cards[pick.index].getAttribute('aria-pressed') === 'true') continue;
    const card = cards[pick.index];
    card.querySelector('.cxk-reward__back').textContent = pick.label;
    card.setAttribute('aria-pressed', 'true');
    if (count === 2) card.setAttribute('data-reward-final', 'true');
    const used = teasers.indexOf(pick.label);
    if (used >= 0) teasers.splice(used, 1);
    count += 1;
  }
  if (count === 3) { cards.forEach(card => { card.disabled = true; }); if (state.stage === 'pick') state.stage = 'email'; }
  updateCount();
  showStep(state.stage);
  const open = () => {
    if (dialog.open) return;
    shown = true;
    opener = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (launcher) { launcher.hidden = true; launcher.setAttribute('aria-expanded', 'true'); }
    dialog.querySelector('[data-reward-close]').focus();
  };
  const close = () => {
    if (advance) { clearTimeout(advance); advance = null; if (count === 3) showStep('email'); }
    dialog.close();
  };
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    opener?.focus?.();
    if (retry) clearTimeout(retry);
    if (launcher) { launcher.hidden = false; launcher.setAttribute('aria-expanded', 'false'); }
    write(localStorage, key, String(Date.now() + (completed ? 30 : Number(dialog.dataset.repeatDays)) * 86400000));
    persist();
  });
  launcher?.addEventListener('click', () => { showStep(completed ? 'code' : state.stage); open(); });
  dialog.querySelectorAll('[data-reward-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  cards.forEach((card, index) => card.addEventListener('click', () => {
    if (card.getAttribute('aria-pressed') === 'true' || count === 3) return;
    const isFinalPick = count === 2;
    const label = isFinalPick ? (dialog.dataset.finalReward || '15% OFF') : teasers.splice(Math.floor(Math.random() * teasers.length), 1)[0];
    card.querySelector('.cxk-reward__back').textContent = label;
    if (isFinalPick) card.setAttribute('data-reward-final', 'true');
    card.setAttribute('aria-pressed', 'true');
    state.picks.push({index, label});
    count += 1;
    updateCount();
    persist();
    burst(isFinalPick);
    if (count === 3) {
      cards.forEach(button => { button.disabled = true; });
      advance = setTimeout(() => { advance = null; showStep('email'); }, 1400);
    }
  }));
  const form = dialog.querySelector('form');
  const query = new URLSearchParams(location.search);
  const returnInput = form.querySelector('[name="return_to"]');
  const previewTheme = query.get('preview_theme_id') || dialog.dataset.previewTheme;
  const finishSignup = () => {
    completed = true;
    state.expires = Date.now() + 30 * 86400000;
    showStep('code');
    remove(sessionStorage, pendingKey);
    write(localStorage, key, String(state.expires));
    if (dialog.open) burst(true);
  };
  form.addEventListener('submit', async event => {
    if (submitted) { event.preventDefault(); return; }
    if (!form.checkValidity()) return;
    const nonce = window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);
    const destination = new URL(location.href);
    destination.searchParams.delete('customer_posted');
    destination.searchParams.set('cxk_reward', nonce);
    if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
    destination.hash = 'cxk-case-reward';
    if (returnInput) returnInput.value = destination.pathname + destination.search + destination.hash;
    write(sessionStorage, pendingKey, JSON.stringify({at: Date.now(), nonce}));
    showStep('email');
    if (event.defaultPrevented || typeof fetch !== 'function' || typeof FormData !== 'function' || typeof DOMParser !== 'function') return;
    event.preventDefault();
    submitted = true;
    const button = form.querySelector('[type=submit]');
    const label = button.textContent;
    const failure = form.querySelector('[data-submit-error]');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.loading;
    form.setAttribute('aria-busy', 'true');
    if (failure) failure.hidden = true;
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeout = controller ? setTimeout(() => controller.abort(), 20000) : null;
    try {
      const action = new URL(form.action, location.href);
      action.hash = '';
      if (previewTheme) action.searchParams.set('preview_theme_id', previewTheme);
      const response = await fetch(action.href, {
        method: 'POST', credentials: 'same-origin', redirect: 'follow',
        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'text/html'},
        body: new URLSearchParams(new FormData(form)).toString(),
        ...(controller ? {signal: controller.signal} : {})
      });
      const returned = new URL(response.url, location.href);
      if (returned.origin === location.origin && returned.pathname.includes('/challenge')) {
        location.assign(returned.href);
        return;
      }
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const error = page.querySelector('#CXKRewardNewsletter [data-reward-error]');
      if (error) throw new Error(error.textContent.trim());
      const serverConfirmed = !!page.querySelector('#CXKRewardNewsletter [data-reward-success]');
      const redirectedToReward = returned.origin === location.origin && returned.searchParams.get('cxk_reward') === nonce;
      if (!response.ok || returned.origin !== location.origin || (!serverConfirmed && !redirectedToReward)) throw new Error(failure?.dataset.default || 'Please try again.');
      finishSignup();
    } catch (error) {
      remove(sessionStorage, pendingKey);
      if (failure) {
        failure.textContent = error.name === 'AbortError' ? failure.dataset.default : (error.message || failure.dataset.default);
        failure.hidden = false;
      }
    } finally {
      if (timeout) clearTimeout(timeout);
      submitted = false;
      button.disabled = false;
      button.setAttribute('aria-disabled', 'false');
      button.textContent = label;
      form.setAttribute('aria-busy', 'false');
    }
  });
  const copy = dialog.querySelector('[data-reward-copy]');
  copy.addEventListener('click', async () => {
    const input = dialog.querySelector('#CXKRewardCode');
    try {
      if (!navigator.clipboard) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(input.value);
      copy.textContent = copy.dataset.copied;
      burst();
    } catch {
      input.focus();
      input.select();
    }
  });
  const token = query.get('cxk_reward');
  const pending = decode(read(sessionStorage, pendingKey));
  const pendingTime = typeof pending === 'number' ? pending : pending?.at;
  const recentPending = pendingTime > Date.now() - 86400000 && pendingTime <= Date.now();
  const confirmedReturn = recentPending && (typeof pending === 'number' ? token === '1' : token === pending?.nonce);
  const hasError = !!dialog.querySelector('[data-reward-error]');
  const serverSuccess = !!dialog.querySelector('[data-reward-success]');
  if (hasError && (token || recentPending)) {
    showStep('email');
    open();
    return;
  }
  if (!hasError && ((token && serverSuccess) || confirmedReturn)) {
    finishSignup();
    open();
    burst(true);
    return;
  }
  if (launcher) launcher.hidden = false;
  if (completed || dialog.dataset.subscriber === 'true' || Number(read(localStorage, key)) > Date.now()) return;
  const competingOverlay = () => !!document.querySelector('dialog[open], cart-drawer.active, cart-drawer[open], .menu-opening, .popup-modal--active, .shopify-cleanslate [role="dialog"]');
  const tryOpen = () => {
    if (!eligible || dialog.open || shown) return;
    if (document.hidden || competingOverlay() || document.activeElement?.matches('input,textarea,select')) {
      if (retry) clearTimeout(retry);
      retry = setTimeout(tryOpen, 1500);
      return;
    }
    window.removeEventListener('scroll', onScroll);
    open();
  };
  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - innerHeight;
    if (scrollable > 0 && scrollY / scrollable >= .3) { eligible = true; tryOpen(); }
  };
  window.addEventListener('scroll', onScroll, {passive: true});
  setTimeout(() => { eligible = true; tryOpen(); }, 6000);
})();
